export default "https://assets.pclncdn.com/web/next-landing/aa74b141/_next/static/images/devices-2630feff4c237888ca229fc9a6b4eb4e.webp";